import { render, staticRenderFns } from "./StockClosingNew.vue?vue&type=template&id=5118a90e&"
import script from "./StockClosingNew.vue?vue&type=script&lang=js&"
export * from "./StockClosingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports